/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ProtocolHistoryPanelState} from 'FileStates';
import CloneModal from 'folder-items/CloneModal';
import EditorActions from 'notebook/protocols/actions/EditorActions';
import ProtocolTabState from 'notebook/protocols/backbone/tabs/ProtocolTabState';
import EditorStore, {ProtocolVersionState} from 'notebook/protocols/stores/EditorStore';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';
import HistoryPanelComponent from 'toolbar/shared/HistoryPanelComponent';
import legacyRunModal from 'ui-library/legacyRunModal';

class ProtocolHistoryPanelConnector extends DataConnector<Props, EnhancedProps> {
  override props: any;
  override shouldSubscribeToRedux = false;
  override stores = [EditorStore];

  enhanceProps(): EnhancedProps {
    return {versionState: EditorStore.getVersionState(this.props.id)};
  }
}

interface Props {
  id: string;
  activate: (...args: Array<any>) => any;
  folderId: string;
  name: string;
  permissions?: any;
}

interface EnhancedProps {
  versionState: ProtocolVersionState;
}

class ProtocolHistoryPanel extends React.Component<Props & EnhancedProps> {
  override render(): JSX.Element {
    return (
      <HistoryPanelComponent
        openVersion={this.openVersion}
        resetToVersion={this.resetToVersion}
        cloneFromVersion={this.cloneFromVersion}
        versions={this.props.versionState.versions}
        // Preserve legacy behavior: the store reports false or omits the field before a version opens.
        // @ts-expect-error HistoryPanelComponent requires a real version ID.
        openVersionId={this.props.versionState.openVersionId}
        isLatest={this.props.versionState.isLatest}
        unsaved={this.props.versionState.unsaved}
        parent={this.props.versionState.parent}
        hasParent={this.props.versionState.hasParent}
        permissions={this.props.permissions}
      />
    );
  }

  openVersion = (versionId: string | number): void => {
    this.props.activate();
    EditorActions.loadVersion(this.props.id, versionId);
  };

  resetToVersion = (): void => {
    EditorActions.resetToOpenVersion(this.props.id);
  };

  cloneFromVersion = (): void => {
    legacyRunModal(CloneModal, {
      modelType: ModelTypeConstants.PROTOCOL,
      id: this.props.id,
      // Preserve legacy behavior: the footer can forward false or undefined before a version opens.
      // @ts-expect-error CloneModal requires a real version ID.
      versionId: this.props.versionState.openVersionId,
      initialName: `${this.props.name} (new)`,
      initialFolderId: this.props.folderId,
    });
  };
}

const ConnectedProtocolHistoryPanel = ProtocolHistoryPanelConnector.connect(ProtocolHistoryPanel);

class ProtocolHistoryPanelView extends ReactPanelBaseView<ProtocolHistoryPanelState, any> {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  activate() {
    return this.model.fileState().findTab(ProtocolTabState).set({active: true});
  }

  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('history'),
        title: 'History',
        component: (
          <ConnectedProtocolHistoryPanel
            id={this.model.id}
            activate={this.activate.bind(this)}
            name={this.model.name()}
            folderId={this.model.folder().api_identifier}
            permissions={this.model.permissions()}
          />
        ),
      },
    ];
  }
}

export default ProtocolHistoryPanelView;
